import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, CalendarClock, XCircle, Repeat, MessageSquare, Smartphone, Pencil } from "lucide-react";
import { Button } from "../ui/button";
import { aiApi } from "./aiApi";
import AIScheduleEditForm from "./AIScheduleEditForm";

export default function AISchedules() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(null);
  const [ask, setAsk] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = () => aiApi.schedules().then((d) => setRows(d.tasks || [])).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const cancel = async (t) => {
    setBusy(t.id);
    try { await aiApi.cancelSchedule(t.id); toast.success(`Jadual '${t.title}' dibatalkan`); setAsk(null); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal batal"); } finally { setBusy(null); }
  };

  if (!rows) return <div className="grid place-items-center h-32"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (!rows.length) return (
    <div className="text-center py-10 text-slate-400 text-sm" data-testid="ai-schedules-empty">
      <CalendarClock className="h-8 w-8 mx-auto mb-2 opacity-50" />Tiada peringatan berjadual aktif.<br />Minta Mimi: “Ingatkan saya setiap Isnin 8 pagi ...”
    </div>
  );
  return (
    <div className="space-y-2" data-testid="ai-schedules">
      {rows.map((t) => (
        <div key={t.id} className="rounded-2xl border border-slate-100 bg-white p-3" data-testid="ai-schedule-item">
          <div className="flex items-start gap-2">
            <CalendarClock className="h-5 w-5 text-fuchsia-500 shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="font-bold text-[13px] text-slate-800">{t.title}</div>
              <div className="text-xs text-slate-500 line-clamp-2 mt-0.5">{t.message || t.instruction}</div>
              <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] text-slate-400 mt-1">
                <span className="font-semibold text-slate-600" data-testid="ai-schedule-next">Seterusnya: {t.next_run_myt} MYT</span>
                <span className="flex items-center gap-0.5"><Repeat className="h-3 w-3" />{t.ulangan}</span>
                <span className="flex items-center gap-0.5">{(t.channels || []).includes("whatsapp") ? <Smartphone className="h-3 w-3" /> : <MessageSquare className="h-3 w-3" />}{(t.channels || []).join(" & ")}</span>
                {t.runs > 0 && <span>{t.runs}x dijalankan</span>}
                {t.user_name && <span>oleh {t.user_name}</span>}
              </div>
            </div>
          </div>
          {ask === t.id ? (
            <div className="flex items-center gap-2 mt-2 rounded-xl bg-rose-50 px-2.5 py-1.5">
              <span className="text-[11.5px] text-rose-700 font-semibold flex-1">Batalkan jadual ini?</span>
              <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setAsk(null)} data-testid="ai-schedule-cancel-no">Tidak</Button>
              <Button size="sm" className="h-7 rounded-lg bg-rose-600 hover:bg-rose-700 text-white text-xs" onClick={() => cancel(t)} disabled={busy === t.id} data-testid="ai-schedule-cancel-yes">
                {busy === t.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Ya, batal"}
              </Button>
            </div>
          ) : edit === t.id ? (
            <AIScheduleEditForm t={t} onCancel={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />
          ) : (
            <div className="flex justify-end gap-1.5 mt-1.5">
              <Button size="sm" variant="outline" className="h-7 rounded-lg text-xs text-fuchsia-700 border-fuchsia-200 hover:bg-fuchsia-50" onClick={() => setEdit(t.id)} data-testid="ai-schedule-edit-btn">
                <Pencil className="h-3.5 w-3.5 mr-1" />Edit
              </Button>
              <Button size="sm" variant="outline" className="h-7 rounded-lg text-xs text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => setAsk(t.id)} data-testid="ai-schedule-cancel-btn">
                <XCircle className="h-3.5 w-3.5 mr-1" />Batal
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
